<template>
  <b-tab class="border-0">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.product.unitMeasure') }}</span>
    </template>

    <McEditableTable
      ref="table"
      v-show="isTableDataAvailable"
      searchable
      hasEmit:submitError
      :fields="fields"
      :apiClient="apiClient"
      :apiErrorMappings="uomApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    />
    <div class="empty-table-container" v-show="!isTableDataAvailable">
      <img :src="illustrationPath" alt />
      <strong>{{ $t('setting.list.product.emptyUnit') }}</strong>
      <p>{{ $t('setting.list.product.add') }}</p>
      <b-button variant="primary" @click="handleAdd">
        <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
      </b-button>
    </div>
  </b-tab>
</template>

<script>
import * as UnitOfMeasurement from '@/services/rest-api/lib/product/unit-of-measurement'
import McEditableTable from '@/components/McEditableTable'
import unitMeasureFields from './lib/fields/unitMeasureFields'
import uomApiErrorMappings from './lib/constants/uom-api-error-mappings'
import { mapGetters } from 'vuex'

export default {
  components: {
    McEditableTable,
  },
  data() {
    return {
      isTableDataAvailable: true,
      uomApiErrorMappings: uomApiErrorMappings,
    }
  },
  computed: {
    fields() {
      return unitMeasureFields
    },
    apiClient() {
      return {
        get: UnitOfMeasurement.get,
        store: UnitOfMeasurement.store,
        show: UnitOfMeasurement.show,
        update: UnitOfMeasurement.update,
        delete: UnitOfMeasurement.deleteSingle,
      }
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.name && data.errors.name[0] == 'value is not unique') {
          this.$mcToast.error('Gagal simpan. Satuan sudah terdaftar di sistem.')
          return
        }

        this.$mcToast.error('Terdapat kesalahan format pada input anda')
      }
    },
  },
}
</script>
